import { useQuery } from "@tanstack/react-query"
import { AXIOS_API_INSTANCE } from "../../Constants";
import { send_authorized_request } from "../../Constants/cognito";

export const useServiceKits = () => {
    // const queryClient = useQueryClient();
    const query = useQuery({
        queryKey: ["serviceKitList"],
        staleTime: 1000 * 60 * 60 * 2, // 60 minutes * 2 = 2 hours
        queryFn: async () => {
            try {
                const response = await AXIOS_API_INSTANCE.get('/servicekits', {
                    params: {
                        order_by: 'name',
                        order_direction: 'asc',
                    }
                })
                return response.data.data
            } catch (error) {
                if (error.response.status === 401) {
                    send_authorized_request()
                }
                throw new Error('Network response was not ok')
            }
        },
        retry: 1,
        placeholderData: []
    })

    return {
        ...query,
        deleteItem: null,
        addItem: null,
        updateItem: null
    }
}

export const findServiceKit = (serviceKits, id) => {
    return (serviceKits ?? []).find((x) => x.id === id)
}